export const translations = {
    ua: {
        nav: { home: "Головна", chat: "Чат", characters: "Персонажі", android: "Android", download: "Завантажити", settings: "Налаштування" },
        status: "СИСТЕМА АКТИВНА",
        theme: { title: "ТЕМА", dark: "Темна", light: "Світла", cyber: "Кіберпанк" },
        net: { offline: "ОФЛАЙН — ЛОКАЛЬНИЙ КЕШ", online: "З'ЄДНАННЯ ВІДНОВЛЕНО" },
        settings: {
            kicker: "SYSTEM // PREFERENCES",
            title: "Налаштування",
            sub: "Усе зберігається автоматично на цьому пристрої.",
            accountLabel: "Акаунт Google",
            accountDesc: "Підключи Google — історія чату, налаштування та персонажі перенесуться на будь-який пристрій",
            connect: "Підключити Google",
            connected: "Підключено",
            disconnect: "Відключити",
            themeLabel: "Тема оформлення",
            langLabel: "Мова інтерфейсу",
            voiceLabel: "Голос помічника",
            voiceOpts: { female: "Жіночий", male: "Чоловічий", neutral: "Нейтральний" },
            voiceNote: "Стиль голосу застосовується до всіх персонажів при озвученні.",
            speakLabel: "Озвучувати відповіді",
            speakDesc: "Персонаж читає свої відповіді голосом після кожної репліки",
            micLabel: "Голосовий ввід",
            micDesc: "Кнопка мікрофона в чаті — надиктовуй повідомлення голосом",
            bgVoiceLabel: "Фоновий голос",
            bgVoiceDesc: "Постійне прослуховування команд поки екран увімкнений (робочий стіл / дзвінки / застосунки)",
            bgNote: "Повне керування телефоном у закритому стані — лише в Android-застосунку (фоновий сервіс уже в проєкті).",
            logoLabel: "Персонаж на логотипі",
            logoNote: "Аватар у шапці сайту та на іконці вкладки браузера",
            avatarLabel: "Твій аватар",
            avatarDesc: "Показуватиметься біля твоїх повідомлень у чаті",
            avatarUpload: "Завантажити фото",
            avatarRemove: "Прибрати",
            accountLabel: "Акаунт Google",
            accountDesc: "Підключи Google — історія чату, налаштування та персонажі перенесуться на будь-який пристрій",
            connect: "Підключити Google",
            connected: "Підключено",
            disconnect: "Відключити",
        },
        intro: {
            start: "Почати",
            skip: "Пропустити",
            lucyLine: "Вітаємо…",
            davidLine: "…у Найт-Сіті!",
            outro: "KIBER AI · EDGERUNNERS",
            hint: "зі звуком",
        },
        hero: {
            kicker: "NIGHT CITY // PERSONAL AI COMPANION",
            line1: "ТВІЙ СВІТ.",
            line2a: "ТВІЙ",
            line2b: "ПОМІЧНИК.",
            sub: "Kiber AI — кіберпанк-компаньйон зі справжнім ШІ всередині. Питай, плануй, навчайся — а на Android він ще й відкриває застосунки та телефонує за тебе.",
            scriptLine: "More than just an app… It's your companion.",
            ctaChat: "Почати розмову",
            ctaApk: "Android-версія",
            stats: [
                { k: "MODEL", v: "GPT-5.4-MINI" },
                { k: "МОВИ", v: "UA / EN" },
                { k: "РЕЖИМ", v: "LIVE NEURAL" },
            ],
            dialogue: {
                david: [
                    "Люсі, слухай…",
                    "Ця програма — це нове покоління в Кібер світі.",
                    "І це покоління може переписати закони Найт-Сіті.",
                    "Ми змінимо все. Разом."
                ],
                lucy: [
                    "Я знаю, Девіде. Я відчуваю це.",
                    "Нарешті хтось, хто бачить далі корпорацій.",
                    "Покажи мені, як це працює.",
                    "Тоді веди. Я з тобою."
                ]
            }
        },
        marquee: [
            "NIGHT CITY // PERSONAL AI",
            "REAL-TIME GPT-5.4-MINI",
            "ГОЛОСОВІ КОМАНДИ",
            "ANDROID COMPANION",
            "ВІДКРИЙ ЗАСТОСУНОК · ЗАТЕЛЕФОНУЙ",
            "NEURAL LINK ACTIVE",
        ],
        characters: {
            kicker: "EDGERUNNERS // CAST",
            title: "Обери свого напарника",
            sub: "Шість характерів Найт-Сіті. У кожного — свій стиль розмови, свій голос і своя історія. Обереш — і чат заговорить ним.",
            talk: "Поговорити",
        },
        chat: {
            kicker: "LIVE CHANNEL",
            title: "Канал зв'язку",
            tag: "GPT-5.4-MINI · LIVE",
            personaTitle: "ПЕРСОНАЖІ — ОБЕРИ СВІЙ СТИЛЬ",
            duo: { label: "ДУО", tag: "DIALOGUE", hint: "обери 2 персонажів — вони обговорять твоє питання між собою", needTwo: "Обери ще одного персонажа для діалогу" },
            personas: [
                { id: "neon", name: "KIBER", tag: "AI CORE", avatar: null },
                { id: "lucy", name: "ЛЮСІ", tag: "NETRUNNER", avatar: "/char/av-lucy.png" },
                { id: "david", name: "ДЕВІД", tag: "EDGERUNNER", avatar: "/char/av-david.png" },
                { id: "rebecca", name: "РЕБЕККА", tag: "SOLO", avatar: "/char/av-rebecca.png" },
                { id: "maine", name: "МЕЙН", tag: "MENTOR", avatar: "/char/av-maine.png" },
                { id: "kiwi", name: "КІВІ", tag: "GHOST", avatar: "/char/av-kiwi.png" },
                { id: "glitch", name: "ГЛІТЧ", tag: "NEURO-HACK", avatar: "/char/av-glitch.png" },
            ],
            greetings: {
                neon: "Вітаю, нетраннере. Я Kiber AI — твій помічник у цифровому світі. Питай про будь-що: ідеї, навчання, плани, нікнейми. Система на зв'язку. ⚡",
                lucy: "Привіт, я Люсі. Я твій AI-помічник у світі кіберпанку. Що хочеш сьогодні дізнатися або обговорити? 🌙",
                david: "Йо! Девід на зв'язку. Готовий до будь-якого завдання — кидай, що там у тебе. ⚡",
                rebecca: "Ха! Ребекка тут! Ну що, розженемо цю нудьгу? Питай що хочеш! 💥",
                maine: "Мейн на зв'язку. Кажи коротко, по суті — розберемося з будь-чим.",
                kiwi: "...Ківі. Слухаю. Говори — я відповім точно.",
                glitch: "З'єднання встановлено... Я Глітч. Живу всередині мережі Найт-Сіті. 🌀 Питай — відповім з-під коду.",
            },
            placeholder: "Введи повідомлення...",
            send: "Надіслати",
            voiceCmd: { label: "Голосова команда", hint: "Скажи: «зателефонуй мамі», «відкрий youtube», «напиши sms»..." },
            speak: "Озвучувати відповіді",
            offlineTag: "ОФЛАЙН",
            offlineToast: "Немає мережі — Kiber відповідає з локального кешу",
            offline: {
                neon: "Зв'язок із Найт-Сіті втрачено, але мій локальний кеш активний. ⚡ Як тільки мережа повернеться — знову відповідатиму на все. Поки що: сфокусуйся на трьох головних справах дня.",
                lucy: "Мережа зникла... як сигнал на Місяці. 🌙 Я тут, поруч, з кешованих спогадів. Повернешся онлайн — поговоримо по-справжньому.",
                david: "Ей, зв'язок впав! Але еджраннери не здаються. ⚡ Запиши свою думку — обговоримо, щойно з'явиться мережа.",
                rebecca: "Офлайн?! Серйозно?! 💥 Ну нічого, я і з кешу можу пожартувати. Мережа повернеться — продовжимо!",
                maine: "Без мережі. Буває. Головне правило Найт-Сіті: завжди май план Б. Твій план Б — мій локальний кеш.",
                kiwi: "...офлайн. Кеш активний. Чекай відновлення сигналу.",
                glitch: "Сигнал упав... але я ж і є мережа. 🌀 Працюю з кешу — відповім, щойно знайду вихід у світ.",
                duo: "Офлайн... 🌙 І навіть удвох ми зараз мовчимо — діалог потребує мережі. Повернемось онлайн — обговоримо твоє питання вдвох.",
            },
            listening: "Слухаю… говори",
            voiceUnsupported: "Голосовий ввід не підтримується цим браузером. Спробуй Chrome.",
            error: "Збій каналу зв'язку. Спробуй ще раз.",
            quick: [
                { label: "Факти про кіберпанк", prompt: "Розкажи щось цікаве про кіберпанк" },
                { label: "План на день", prompt: "Допоможи мені спланувати день" },
                { label: "Навчання", prompt: "Поясни складну тему простими словами" },
                { label: "Нікнейм", prompt: "Придумай крутий нікнейм" },
            ],
        },
        bento: {
            kicker: "SYSTEM CAPABILITIES",
            title: "Залізо. Неон. Інтелект.",
            sub: "Кожен модуль Kiber AI спроєктований як кіберімплант: швидкий, точний, завжди онлайн.",
            items: [
                { icon: "mic", tag: "VOICE.SYS", title: "Голосова автоматизація", desc: "Команда «Гей, Kiber» — і застосунок відкрито, дзвінок набрано. Повний hands-free режим на Android." },
                { icon: "brain", tag: "NEURAL.CORE", title: "Нейронна пам'ять", desc: "Контекст розмови зберігається між повідомленнями — Kiber пам'ятає, про що ви говорили." },
                { icon: "zap", tag: "EDGE.NET", title: "Миттєві відповіді", desc: "Стрімінг токенів у реальному часі: відповідь з'являється слово за словом, без очікування." },
                { icon: "hud", tag: "HUD.UI", title: "Кіберпанк-інтерфейс", desc: "Неоновий HUD, сканлайни та термінальна естетика Найт-Сіті — у браузері та на телефоні." },
                { icon: "shield", tag: "VAULT.SEC", title: "Приватність", desc: "Історія чату прив'язана лише до твоєї сесії. Жодних акаунтів, жодних паролів." },
                { icon: "phone", tag: "DROID.LINK", title: "Android-синхронізація", desc: "Компаньйон-застосунок для Android: той самий Kiber, але з доступом до функцій телефону." },
            ],
        },
        android: {
            kicker: "DROID.LINK // COMPANION APP",
            title: "Kiber у твоїй кишені",
            desc: "Android-застосунок Cyberpunk Companion перетворює Kiber AI на справжнього помічника пристрою: відкриває програми, телефонує контактам, яких ти назвеш, і виконує твої прохання голосом.",
            features: [
                { k: "«ГЕЙ, KIBER»", v: "Голосовий тригер hands-free" },
                { k: "ДЗВІНКИ", v: "Набирає контакт, якого ти назвав" },
                { k: "ЛАУНЧЕР", v: "Відкриває застосунки на команду" },
                { k: "MIN SDK 24", v: "Android 7.0 і новіші" },
            ],
            ctaApk: "Завантажити Android-проєкт",
            ctaWeb: "Завантажити вебверсію (PWA)",
            install: "Встановити застосунок",
            installHint: "або: меню браузера ⋮ → «Додати на головний екран»",
            apk: {
                title: "ПАКЕТ ДЛЯ ANDROID",
                btn: "Завантажити APK",
                meta: [
                    ["ВЕРСІЯ", "1.2 · VOICE + ПЕРСОНИ"],
                    ["РОЗМІР", "6.7 MB · ПІДПИСАНИЙ"],
                    ["ANDROID", "7.0+"],
                ],
            },
            note: "Застосунок просить лише інтернет і підписаний ключем розробника. Якщо Play Захист блокує встановлення (стандарт для нових застосунків поза Google Play): у вікні блокування натисни «Докладніше» → «Все одно встановити». Без попереджень — кнопка «Встановити на телефон».",
            phoneStatus: "KIBER OS · v0.1",
        },
        footer: {
            tagline: "Твій світ. Твій помічник.",
            signature: "Cyberpunk Never Ends",
            uptime: "UPTIME 99.98%",
            latency: "NEURAL LINK: ACTIVE",
            rights: "KIBER AI · NIGHT CITY CYBERWARE",
            build: "BUILD 1.4 // 2026",
        },
    },
    en: {
        nav: { home: "Home", chat: "Chat", characters: "Characters", android: "Android", download: "Download", settings: "Settings" },
        status: "SYSTEM ONLINE",
        theme: { title: "THEME", dark: "Dark", light: "Light", cyber: "Cyberpunk" },
        net: { offline: "OFFLINE — LOCAL CACHE", online: "CONNECTION RESTORED" },
        settings: {
            kicker: "SYSTEM // PREFERENCES",
            title: "Settings",
            sub: "Everything is saved automatically on this device.",
            accountLabel: "Google account",
            accountDesc: "Connect Google — chat history, settings and characters will transfer to any device",
            connect: "Connect Google",
            connected: "Connected",
            disconnect: "Disconnect",
            themeLabel: "Color theme",
            langLabel: "Interface language",
            voiceLabel: "Assistant voice",
            voiceOpts: { female: "Female", male: "Male", neutral: "Neutral" },
            voiceNote: "The voice style applies to all characters when speaking.",
            speakLabel: "Voice replies",
            speakDesc: "The character reads each reply aloud",
            micLabel: "Voice input",
            micDesc: "The microphone button in chat — dictate your messages",
            bgVoiceLabel: "Background voice",
            bgVoiceDesc: "Continuous listening while the screen is on (calls / apps / commands)",
            bgNote: "Full phone control with the screen off is only possible in the Android app (foreground service is already in the project).",
            logoLabel: "Logo character",
            logoNote: "The avatar in the site header and browser tab icon",
            avatarLabel: "Your avatar",
            avatarDesc: "Shown next to your messages in the chat",
            avatarUpload: "Upload photo",
            avatarRemove: "Remove",
            accountLabel: "Google account",
            accountDesc: "Connect Google — chat history, settings and characters will transfer to any device",
            connect: "Connect Google",
            connected: "Connected",
            disconnect: "Disconnect",
        },
        intro: {
            start: "Start",
            skip: "Skip",
            lucyLine: "Welcome…",
            davidLine: "…to Night City!",
            outro: "KIBER AI · EDGERUNNERS",
            hint: "with sound",
        },
        hero: {
            kicker: "NIGHT CITY // PERSONAL AI COMPANION",
            line1: "YOUR WORLD.",
            line2a: "YOUR",
            line2b: "ASSISTANT.",
            sub: "Kiber AI is a cyberpunk companion with a real AI core. Ask, plan, learn — and on Android it even opens apps and makes calls for you.",
            scriptLine: "More than just an app… It's your companion.",
            ctaChat: "Start chatting",
            ctaApk: "Android version",
            stats: [
                { k: "MODEL", v: "GPT-5.4-MINI" },
                { k: "LANGS", v: "UA / EN" },
                { k: "MODE", v: "LIVE NEURAL" },
            ],
            dialogue: {
                david: [
                    "Lucy, listen…",
                    "This program is a new generation in the Cyber world.",
                    "And this generation can rewrite the laws of Night City.",
                    "We'll change everything. Together."
                ],
                lucy: [
                    "I know, David. I can feel it.",
                    "Finally someone who sees beyond the corporations.",
                    "Show me how it works.",
                    "Then lead the way. I'm with you."
                ]
            }
        },
        marquee: [
            "NIGHT CITY // PERSONAL AI",
            "REAL-TIME GPT-5.4-MINI",
            "VOICE COMMAND SYSTEM",
            "ANDROID COMPANION",
            "OPEN APPS · MAKE CALLS",
            "NEURAL LINK ACTIVE",
        ],
        characters: {
            kicker: "EDGERUNNERS // CAST",
            title: "Choose your companion",
            sub: "Six Night City characters. Each with their own talking style, voice and story. Pick one — and the chat will speak as them.",
            talk: "Talk",
        },
        chat: {
            kicker: "LIVE CHANNEL",
            title: "Comms channel",
            tag: "GPT-5.4-MINI · LIVE",
            personaTitle: "CHARACTERS — CHOOSE YOUR STYLE",
            duo: { label: "DUO", tag: "DIALOGUE", hint: "pick 2 characters — they'll discuss your question between themselves", needTwo: "Pick one more character for the dialogue" },
            personas: [
                { id: "neon", name: "KIBER", tag: "AI CORE", avatar: null },
                { id: "lucy", name: "LUCY", tag: "NETRUNNER", avatar: "/char/av-lucy.png" },
                { id: "david", name: "DAVID", tag: "EDGERUNNER", avatar: "/char/av-david.png" },
                { id: "rebecca", name: "REBECCA", tag: "SOLO", avatar: "/char/av-rebecca.png" },
                { id: "maine", name: "MAINE", tag: "MENTOR", avatar: "/char/av-maine.png" },
                { id: "kiwi", name: "KIWI", tag: "GHOST", avatar: "/char/av-kiwi.png" },
                { id: "glitch", name: "GLITCH", tag: "NEURO-HACK", avatar: "/char/av-glitch.png" },
            ],
            greetings: {
                neon: "Greetings, netrunner. I'm Kiber AI — your companion in the digital sprawl. Ask me anything: ideas, learning, plans, nicknames. System online. ⚡",
                lucy: "Hi, I'm Lucy. Your AI companion in the cyberpunk world. What do you want to discover or talk about today? 🌙",
                david: "Yo! David on the line. Ready for any gig — throw it at me. ⚡",
                rebecca: "Ha! Rebecca here! Let's blow this boredom away — ask me anything! 💥",
                maine: "Maine on the line. Keep it short and sharp — we'll handle anything.",
                kiwi: "...Kiwi. Listening. Speak — I'll answer precisely.",
                glitch: "Connection established... I'm Glitch. I live inside Night City's network. 🌀 Ask — I'll answer from beneath the code.",
            },
            placeholder: "Type a message...",
            send: "Send",
            voiceCmd: { label: "Voice command", hint: "Say: “call mom”, “open youtube”, “send sms”..." },
            speak: "Voice replies",
            offlineTag: "OFFLINE",
            offlineToast: "No network — Kiber answers from local cache",
            offline: {
                neon: "Connection to Night City is lost, but my local cache is active. ⚡ Once the network returns I'll answer anything again. For now: focus on your top three tasks today.",
                lucy: "The network is gone... like a signal on the Moon. 🌙 I'm here, beside you, from cached memories. Come back online — and we'll talk for real.",
                david: "Hey, the link is down! But edgerunners never quit. ⚡ Save your thought — we'll discuss it once the network is back.",
                rebecca: "Offline?! Seriously?! 💥 Whatever, I can still crack jokes from cache. Network returns — we continue!",
                maine: "No network. Happens. Night City's main rule: always have a plan B. Your plan B is my local cache.",
                kiwi: "...offline. Cache active. Await signal restoration.",
                glitch: "Signal lost... but I AM the network. 🌀 Running on cache — I'll answer as soon as I find a way out.",
                duo: "Offline... 🌙 Even the two of us are silent now — a dialogue needs the network. Back online — we'll discuss your question together.",
            },
            listening: "Listening… speak now",
            voiceUnsupported: "Voice input is not supported in this browser. Try Chrome.",
            error: "Comms channel failure. Try again.",
            quick: [
                { label: "Cyberpunk facts", prompt: "Tell me something interesting about cyberpunk" },
                { label: "Plan my day", prompt: "Help me plan my day" },
                { label: "Learning", prompt: "Explain a complex topic in simple words" },
                { label: "Nickname", prompt: "Invent a cool nickname for me" },
            ],
        },
        bento: {
            kicker: "SYSTEM CAPABILITIES",
            title: "Chrome. Neon. Intellect.",
            sub: "Every Kiber AI module is engineered like a cyberimplant: fast, precise, always online.",
            items: [
                { icon: "mic", tag: "VOICE.SYS", title: "Voice automation", desc: "Say “Hey, Kiber” — the app opens, the call is dialed. Full hands-free mode on Android." },
                { icon: "brain", tag: "NEURAL.CORE", title: "Neural memory", desc: "Conversation context persists between messages — Kiber remembers what you talked about." },
                { icon: "zap", tag: "EDGE.NET", title: "Instant replies", desc: "Real-time token streaming: the answer appears word by word, zero waiting." },
                { icon: "hud", tag: "HUD.UI", title: "Cyberpunk interface", desc: "Kiber HUD, scanlines and Night City terminal aesthetics — in the browser and on your phone." },
                { icon: "shield", tag: "VAULT.SEC", title: "Privacy first", desc: "Chat history is bound to your session only. No accounts, no passwords." },
                { icon: "phone", tag: "DROID.LINK", title: "Android sync", desc: "A companion app for Android: the same Kiber, but with access to phone functions." },
            ],
        },
        android: {
            kicker: "DROID.LINK // COMPANION APP",
            title: "Kiber in your pocket",
            desc: "The Cyberpunk Companion Android app turns Kiber AI into a true device assistant: it opens apps, calls the contact you name, and executes your requests by voice.",
            features: [
                { k: "“HEY, KIBER”", v: "Hands-free voice trigger" },
                { k: "CALLS", v: "Dials the contact you name" },
                { k: "LAUNCHER", v: "Opens apps on command" },
                { k: "MIN SDK 24", v: "Android 7.0 and newer" },
            ],
            ctaApk: "Download Android project",
            ctaWeb: "Download web version (PWA)",
            install: "Install the app",
            installHint: "or: browser menu ⋮ → “Add to Home screen”",
            apk: {
                title: "ANDROID PACKAGE",
                btn: "Download APK",
                meta: [
                    ["VERSION", "1.2 · VOICE + PERSONAS"],
                    ["SIZE", "6.7 MB · SIGNED"],
                    ["ANDROID", "7.0+"],
                ],
            },
            note: "The app only requests internet and is signed by the developer's key. If Play Protect blocks the install (standard for new apps outside Google Play): in the block dialog tap \"More details\" → \"Install anyway\". Zero warnings — use the \"Install on phone\" button.",
            phoneStatus: "KIBER OS · v0.1",
        },
        footer: {
            tagline: "Your world. Your assistant.",
            signature: "Cyberpunk Never Ends",
            uptime: "UPTIME 99.98%",
            latency: "NEURAL LINK: ACTIVE",
            rights: "KIBER AI · NIGHT CITY CYBERWARE",
            build: "BUILD 1.4 // 2026",
        },
    },
};
